import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import * as types from '../../lib/constants';
import config from '../../config';
import expand from '../../images/googleMap/googlemap_expand.png';
import contract from '../../images/googleMap/googlemap_contract.png';

const { googleMapApiKey } = config;

const style = {
  main: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  map: {
    width: '100%',
    height: '100%',
  },
  fullscreenControl: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 25,
    height: 25,
    margin: 5,
    cursor: 'pointer',
  },
};

const InitialMap = ({ position }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: googleMapApiKey,
  });

  if (loadError) {
    return 'Load Error';
  }

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={style.map}
      options={types.GOOGLE_MAP_DEFAULT_OPTIONS_MEDIA}
      zoom={types.GOOGLE_MAP_DEFAULT_ZOOM}
      mapTypeId="roadmap"
      center={position}
    >
      <Marker position={position} />
    </GoogleMap>
  ) : (
    'Loading...'
  );
};
InitialMap.propTypes = {
  position: PropTypes.object.isRequired,
};

const MediaMap = ({ mediaInfo, fullscreen, onToggleFullScreen }) => {
  const linkToImage = (fullscreen && contract) || expand;
  const { lat, lng } = mediaInfo;
  const position = { lat, lng };
  return (
    <div style={style.main}>
      <InitialMap position={position} />
      <div
        id="clickMediaMapButton"
        style={style.fullscreenControl}
        role="presentation"
        alt="fullscreenButton"
        onClick={() => onToggleFullScreen()}
      >
        <img src={linkToImage} alt="mediaMapOpenCloseButton" />
      </div>
    </div>
  );
};

MediaMap.propTypes = {
  mediaInfo: PropTypes.object.isRequired,
  fullscreen: PropTypes.bool.isRequired,
  onToggleFullScreen: PropTypes.func.isRequired,
};

export default MediaMap;
